import {configOption, configSubObject, KahunConfigurationOptionType} from "../lib/annotations";
import {LLMOptions} from "./llmOptions";

export enum SortType {
  BestMatch = "BestMatch",
  PatientProb = "PatientProb",
  Prob = "Prob",
  Urgency = "Urgency",
}

export enum RedundancyFilter {
  NotCausingAbnormalForAbnormalMainFinding = "NotCausingAbnormalForAbnormalMainFinding",
  NotCausingAbnormalForBackgroundMainFinding = "NotCausingAbnormalForBackgroundMainFinding",
  //The distinction between the two is not implemented yet.
  CauseAbnormalOnlyThroughAncestor = "CauseAbnormalOnlyThroughAncestor",
  CauseAbnormalOnlyThroughComplication = "CauseAbnormalOnlyThroughComplication",

  HealthyControlIsRedundant = "HealthyControlIsRedundant"

}
export class DiagnosisOptions {

  @configOption({
    description: "reduce the leak of some kinds of findings.",
  })
  addPrevalenceSmoothFactor?: boolean = true;

  @configOption({
    description:
      "Fetching close nodes instead the given qf if the corresponding node isn't in the graph.",
  })
  traverseToSubTypeFinding?: boolean = true;

  @configOption({
    description:
      'Do we want to "explain" active findings using paths from background findings? (hence, reduce the prob of diseases cause those findings)',
  })
  explainActiveUsingBackgroundDisorder?: boolean = false;

  @configOption({
    description: "reduce the lift of active findings by exponent -1/4 ",
  })
  softenActiveFindingLift?: boolean = false;

  @configOption({
    description:
      "reduce the affect of multiple negated lifts (by  increasing the negative loglift to be closer to 0)",
  })
  increaseNegatedSymptomsLift?: boolean = true;

  @configOption({
    description:
      "Use Max function instead of NoisyOr when merging multiple paths into one number",
  })
  noisyOrAsMax?: boolean = true;

  @configOption({
    description:
      "Do we want the solver to recompute metrics on run-time even if not needed ? TO be used only for reports",
  })
  forceRecompute?: boolean = false;

  @configOption({
    description:
      "Output the used paths for every computed metric. To be used only for reports",
  })
  outputUsedPaths?: boolean = false;

  @configOption({
    description:
    "Output the candidated paths as used paths for every computed metric. (A -> B -> C will be outputed even if there's A->C) "
  })
  allCandidatePathsAsUsedPaths?: boolean = false;

  @configOption({
    description:
      "allow long-term patient findings (contditions) to be also a suspected disease. (e..g DM, Pregnancy, etc.) ",
  })
  includeFlareUpsInDD?: boolean = true;

  @configOption({
    description:
      "reduce the lift of symptoms with duration significatlly shorter than the suspected disease's common length",
  })
  reduceChronicDiseaseVsAcuteSymptomProb?: boolean = true;

  @configOption({
    description:
      "assuming that explainActiveUsingBackgroundDisorder is on, do we want to reduce the sensitivity of active findings explained by background findings by exponent 1/2 ",
  })
  reduceBackgroundActiveSymptomProb?: boolean = true;

  @configOption({
    description:
      "Only present diseases that the client sent. Maybe for mini view in agent?",
  })
  useOnlyDiseasesToContain?: boolean = false;

  @configOption({
    isObsolete: true,
  })
  flexClustering?: boolean = false;

  @configOption({
    displayName: "Flex Clustering - Collapse Cap",
    displayType: KahunConfigurationOptionType.Float,
    isObsolete: true,
  })
  flexClustering_COLLAPSE_CAP?: number = 10.0;

  @configOption({
    displayName: "Flex Clustering - Collapse Cap Ratio",
    isObsolete: true,
  })
  flexClustering_COLLAPSE_CAP_RATIO?: number = 0.2;

  @configOption({
    description:
      "What exponent-factor to apply on the incidence of diseases on Urgency sort  type (next step, agent sorts)",
    displayType: KahunConfigurationOptionType.Float,
  })
  urgencySortIncidenceExp?: number = 0.6667;

  @configOption({
    displayType: KahunConfigurationOptionType.Float,
    description:
      "What exponent-factor to apply on the incidence of diseases on patient1st sort  type (results page)",
  })
  patientSortIncidenceExp?: number = 1.5;

  @configOption({
    description:
      "Limit the candidate diseases to the top X ordered by some heuristic taking into consideration active positive findings only",
  })
  candidatesUseTopPerCurated?: boolean = false;

  @configOption({
    description:
      "Limit the candidate diseases to the top X ordered by some heuristic taking into consideration active positive findings only works only if candidateUseTopPerCurated is TRUE.",
  })
  candidatesLimitDiseases?: number = 500;

  @configOption({
    isObsolete: true,
    description:
        "The minimal limit on the lift of a disease in order to be allowed to show, taking all findings into account",
  })
  validLiftLimit?: number = 0;

  @configOption({
    description:
        "The minimal limit on the lift of a disease in order to be allowed to show, taking ALL findings into account",
  })
  totalLiftLimit?: number = 0;

  @configOption({
    description:
        "The minimal limit on the lift of a disease in order to be allowed to show, taking only positive ABNORMAL findings into account",
  })
  abnormalLiftLimit?: number = 0;

  @configOption({
    description:"The importance factor of main finding (leak is modified) ",
  })
  mainFindingLeakFactor?: number = 100;

  @configOption({
    description:"The importance factor of a finding that is volunteered (leak is modified) ",
  })
  volunteeredSourceLeakFactor?: number = 10;

  @configOption({
    description:"The importance factor of a finding that we suggested an got response to (leak is modified) ",
  })
  suggestedSourceLeakFactor?: number = 1;

  @configOption({
    description:"The importance factor of a finding that taken by a physician (leak is modified) ",
  })
  physicianSourceLeakFactor?: number = 1;

  @configOption({
    description:
      "above this number remove the less likely clusters. < 0 to ignore.",
  })
  clustersMostLikelyThreshold?: number = 0; //above this number remove the less likely clusters. <= 0 to ignore.

  @configOption({
    description: "at most less likely diseases",
  })
  clustersLessLikelyMax?: number = 0; //at most less likely diseases. <= 0 to ignore

  @configOption({
    description: "keep only clusters above this prob",
    displayType: KahunConfigurationOptionType.Float,
  })
  clusterProbThreshold?: number = 0; // keep only clusters above this prob

  @configOption({
    displayType: KahunConfigurationOptionType.Float,
    description:
      "calcaulate urgency based on diseases prob higher than this " +
      "I think it is obsolete " +
      "Need to check",
  })
  urgencySubTypeMin?: number = 0.05; // calcaulate urgency based on diseases prob higher then this

  @configOption({
    description:
      'Factor applied on "presentable diseases" for patient without presenting symptoms (1 means no factor)',
  })
  missingPresentingSymptomsFactor?: number = 1; // factor applied on missing presenting symptom. factor of 1 meaning the flag is disabled.

  @configOption({
    description:
      "Output clusters with redundant diseases\\clusters, reports only",
  })
  includeRedundantInReport?: boolean = false;

  @configOption({
    description: "If true, and if the least 'most likely' disease is close to the top 'less likely' disease, run adaptive grouping again on the 'less likely' group and append the top from there."
  })
  topBottom2ndPass?: boolean = true;

  @configOption({ isObsolete: true })
  filterCovid?: boolean = false;

  @configOption({
    description:
      "Add possible complications of diagnosis list to the diagnosis list",
  })
  possibleComplications?: boolean = false;

  @configOption({
    options: SortType,
    description:
      "The sort type for which we want to take the top diseases for possible complications.",
  })
  sortTypeOfPossibleComplications?: SortType = SortType.Urgency;

  @configOption({
    description:
      "Pass numerator \\ denumerator steps from 40xCR lambdas to diagnosis lambda. It reduces running time, but note that this option will be set to be true if outputUsedPaths or possibleComplications are true ",
  })
  outputSteps?: boolean = false;

  @configOption({
    description:
        "Suspected localized disease (such as Arthritis in right wrist joint) ",
  })
  localizedDiseases?: boolean = true;

  @configOption({
    description: "Show full hierarchy of uniq-subtypes findings."
  })
  outputFullSubtypesHierarchyExplenations?: boolean = false;

  @configOption({
    displayType: KahunConfigurationOptionType.WPolicy,
    description: "List of policies ID for the diagnose to use (Used during diagnose tests)",
  })
  policies?: string[] = [];

  @configOption({
    description: "Which redundant diseases to filter out",
  })
  redundancyFilters?: RedundancyFilter[] = [
      RedundancyFilter.NotCausingAbnormalForBackgroundMainFinding,
      RedundancyFilter.NotCausingAbnormalForAbnormalMainFinding,
      RedundancyFilter.CauseAbnormalOnlyThroughAncestor,
      RedundancyFilter.CauseAbnormalOnlyThroughComplication,
      RedundancyFilter.HealthyControlIsRedundant
  ];

  @configOption({
    displayType: KahunConfigurationOptionType.Boolean,
    description: "Use LLM in place of solver",
  })
  useLLM?: boolean = false;

  @configSubObject({
    description: "Configuration options for the LLM (when use-llm enabled) * Deprecated - use root.llmOptions *",
    displayName: "LLM Configuration"
  })
  llmOptions?: LLMOptions;
}
